import { render } from "./hamburger.vue?vue&type=template&id=0a980034"
const script = {}
script.render = render

export default script